import PropTypes from 'prop-types';
import { buttonBtnTypeData, buttonSkinData, buttonSizeData } from '~button';
import adsBannerOrientationData from '../data/adsBannerOrientationData';
var policyListItem = PropTypes.shape({
  policyTitle: PropTypes.string.isRequired,
  policy: PropTypes.arrayOf(PropTypes.shape({
    policyItemBody: PropTypes.string.isRequired,
    policyItemTitle: PropTypes.string.isRequired
  }).isRequired).isRequired
}).isRequired;
var policyList = PropTypes.arrayOf(policyListItem);
var styleOptions = PropTypes.arrayOf(PropTypes.shape({
  value: PropTypes.string,
  label: PropTypes.string
}));
var adsItem = PropTypes.shape({
  title: PropTypes.string,
  collectionTitle: PropTypes.string,
  shortDescription: PropTypes.string,
  image: PropTypes.string,
  discount: PropTypes.number,
  url: PropTypes.string
});
var adsItems = PropTypes.arrayOf(adsItem);
var adsBannerOrientationOptions = PropTypes.oneOf(adsBannerOrientationData);
var productFeatureCtaBtn = PropTypes.shape({
  btnType: PropTypes.oneOf(buttonBtnTypeData),
  skin: PropTypes.oneOf(buttonSkinData),
  size: PropTypes.oneOf(buttonSizeData)
});
var asideAsset = PropTypes.shape({
  asset: PropTypes.shape({
    asset: PropTypes.string,
    height: PropTypes.number
  })
});
var asideComposition = PropTypes.shape({
  composition: PropTypes.node
});
var productFeatureAside = PropTypes.oneOfType([asideAsset, asideComposition]);
var productFeatureColMedia = PropTypes.shape({
  xxs: PropTypes.number,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number
});
var productFeature = PropTypes.shape({
  isFullWidth: PropTypes.bool,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  alternatePosition: PropTypes.bool,
  to: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaBtn: productFeatureCtaBtn,
  isTablet: PropTypes.bool,
  aside: productFeatureAside,
  descriptionColMedia: productFeatureColMedia,
  assetColMedia: productFeatureColMedia,
  alignItems: PropTypes.string,
  descriptionHorizontalSpacing: PropTypes.number,
  asideHorizontalSpacing: PropTypes.number
});
var productFeatureList = PropTypes.arrayOf(productFeature);
export default {
  policyList: policyList,
  policyListItem: policyListItem,
  styleOptions: styleOptions,
  adsItem: adsItem,
  adsItems: adsItems,
  adsBannerOrientationOptions: adsBannerOrientationOptions,
  productFeatureCtaBtn: productFeatureCtaBtn,
  productFeatureAside: productFeatureAside,
  productFeature: productFeature,
  productFeatureList: productFeatureList,
  productFeatureColMedia: productFeatureColMedia
};